<template>
	<div class="content-wrapper">
		<section class="content">
			<div class="box">
				<div class="box-header with-border heading-cart clearfix">
					<div class="clearfix pull-left col-md-8">
						<h3 class="box-title">Sticky</h3>
						<span class="text-danger animated flash config-notif" v-if="selectedBucketNameToImportConfig">
							Imported config from {{selectedBucketNameToImportConfig}} Bucket. Click save to use the config.
						</span>
					</div>
					<div class="pull-left clearfix import col-md-1 text-center">
						<el-switch v-model="stickyConfig.isEnabled" on-color="#13ce66" off-color="#ff4949"> </el-switch>
					</div>
					<div class="pull-right clearfix import col-md-3">
						<div class="col-md-9 text-right">
							<el-dropdown trigger="click" @command="selectBucketModule" v-show="!selectedBucketNameToImportConfig">
								<el-button type="primary" :title="'Import Config'"> 
									Import Config <i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item v-for="(bucket, index) in bucketListForModuleConfig" :command="index">{{bucket.bucketName}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<button class="el-button el-button--danger" v-on:click.prevent="removeSelectedModuleConfig()" v-show="selectedBucketNameToImportConfig">Reset</button>
						</div>
						<div class="col-md-3 no-padding">
							<button class="el-button el-button--success" @click="saveAndPublishAxtSticky()">Save</button>
						</div>
					</div>					
				</div>
				<div class="box-body">
					<template>
						<el-table :data="stickyConfigsList" stripe height="400" style="width: 100%">
							<!-- <el-table-column type="selection" width="30">
							</el-table-column> -->
							<el-table-column prop="layout" sortable :filters="filterList" :filter-method="layoutFilterHandler" label="Layout">
							</el-table-column>
							<el-table-column prop="alias_name" label="Ad Spot">
							</el-table-column>
							<el-table-column label="Start Point">
								<template slot-scope="props">
									{{ props.row.startPoint ? props.row.startPoint : '-' }}
								</template>
							</el-table-column>
							<el-table-column label="End Point">
								<template slot-scope="props">
									{{ props.row.endPoint ? props.row.endPoint : '-' }}
								</template>
							</el-table-column>
							<el-table-column label="Timer(sec)">
								<template slot-scope="props">
									{{ props.row.timer > 0 ? props.row.timer : '-' }}
								</template>
							</el-table-column>
							<el-table-column label="Edit" width="50">
								<template slot-scope="props">
									<button class="el-button btn-rounded el-button--success edit" @click="editStickyConfig(props.row)">
										<i class="ti-pencil"></i>
									</button>
								</template>
							</el-table-column>
							<el-table-column label="Delete" width="60">
								<template slot-scope="props">
									<button class="el-button btn-rounded el-button--danger edit" @click="deleteStickyUnitConfig(props.row)">
										<i class="ti-close"></i>
									</button>
								</template>
							</el-table-column>
						</el-table>
					</template>
					
					<form method="post" v-on:submit.prevent="addStickyUnitConfig" class="form">
						<div class="row clearfix">
							<div class="col-md-4">
								<p class="form-label">Layout</p>
								<el-select v-model="stickyUnitConfig.layout" filterable placeholder="Select a Layout" @change="getAdSpots">
									<el-option v-for="layout in layoutsList" :key="layout.id" :label="layout.layout_name" :value="layout.id"></el-option>
								</el-select>
							</div>
							<div class="col-md-4">
								<p class="form-label">Main Selector(Ad Spot)</p>
								<el-select v-model="stickyUnitConfig.layoutAdSpots" filterable placeholder="Select a AdSpot">
									<el-option v-for="adSpot in layoutAdSpotsList" :key="adSpot.id" :label="adSpot.adSpot" :value="adSpot.id"></el-option>
								</el-select>
							</div>
							<div class="col-md-4">
								<p class="form-label">Timer(sec)</p>
								<el-input placeholder="Timer" type="number" value="1" min="0" max="600" v-model="stickyUnitConfig.timer"></el-input>
							</div>

							<div class="col-md-4 m-t-15">
								<p class="form-label">Start Point</p>
								<el-input placeholder="Start-point" v-model="stickyUnitConfig.startPoint"></el-input>
							</div>
							<div class="col-md-4 m-t-15">
								<p class="form-label">End Point</p>
								<el-input placeholder="End-point" v-model="stickyUnitConfig.endPoint"></el-input>
							</div>
							<div class="col-md-4 m-t-15">
								<p class="form-label">More CSS</p>
								<el-input placeholder="CSS to fix the ad unit" v-model="stickyUnitConfig.moreCSS"></el-input>
							</div>
							<div class="col-md-4 m-t-15">
								<p class="form-label">Top</p>
								<el-input type="number" placeholder="Top value to avoid header overlap" v-model="stickyUnitConfig.top"></el-input>
							</div>
							
							<div class="col-md-12 m-t-15 text-right">
								<button class="el-button el-button--success" type="submit">{{ stickyUnitConfig.editId ? 'Update' : 'Save' }}</button>
								<button class="el-button el-button--danger" type="button" @click="clearForm()" v-show="stickyUnitConfig.editId">Clear</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</section>
	</div>
</template>
<script type="text/javascript">
	import axios from 'axios';
	export default {
		data() {
			return {
				module : 'sticky',
				bucketId : undefined,
				stickyConfig : {
					isEnabled : false
				},
				adunits : [],
				stickyConfigsList : [],
				stickyUnitConfig : {
					editId: undefined,
					layout : undefined,
					layoutAdSpots : undefined,
					adSelectorRef : undefined,
					isTimer : undefined,
					startPoint : undefined,
					endPoint : undefined,
					timer : 0,
					moreCSS: undefined,
					top: 0
				},
				layoutsList : [],
				layoutAdSpotsList : [],
				bucketListForModuleConfig : [],
				selectedBucketToImportConfig : undefined,
				selectedBucketNameToImportConfig : undefined
			};
		},
		created: function(){
			this.cloneConfig = JSON.parse(JSON.stringify(this.stickyUnitConfig));
			this.bucketId = this.$route.params.bucketId;
			this.domain = this.$route.params.domId;
			this.$nextTick(function () {
				this.getListOfBucketConfig();
				this.getStickyConfig(this.bucketId);
				this.getStickyUnitConfig(this.bucketId);
			});
		},
		methods: {
			clearForm(){
				this.stickyUnitConfig = JSON.parse(JSON.stringify(this.cloneConfig));
			},
			getListOfBucketConfig: function(){
				axios.post(BASE_URL + 'v1/get_bucket_config_list/', {bucketId : this.bucketId, module : this.module})
				.then(response => {
					if (response.data.response_data.status) {
						this.bucketListForModuleConfig = response.data.response_data.bucket_list;
					}
				})
				.catch(e => {
					console.log();
				});
			},
			notificationMsg: function(type = 'Error', msg){
				this.$notify({
					title: type,
					message: (msg) ? msg : 'Oops Something went wrong!',
					type: type.toLowerCase()
				});
			},
			saveAndPublishAxtSticky: function(){
				axios.post(BASE_URL + 'v1/create_sticky_module/', {
					bucketId: this.bucketId,
					isActive: this.stickyConfig.isEnabled
				})
				.then(response => {
					if (response.data.response_data.status) {
						this.notificationMsg('Success',response.data.response_data.message);
						if(this.selectedBucketToImportConfig){
							this.importStickyConfig();
						}
						this.stickyConfigsList = [];
						this.getStickyConfig(this.bucketId);
						this.getStickyUnitConfig(this.bucketId);
					} else {
						this.notificationMsg('Warning',response.data.response_data.message);
					}
				})
				.catch(e => {
					console.log(e);
				});
			},
			getStickyConfig: function(bucketId){
				axios.post(BASE_URL + 'v1/sticky_module/', {bucketId : bucketId})
				.then(response => {
					this.stickyConfig.isEnabled = response.data.response_data.isActive;
					this.layoutsList = response.data.response_data.data.domain_layouts;
				})
				.catch(e => {
					console.log(e);
				});
			},
			getStickyUnitConfig: function(bucketId){
				axios.post(BASE_URL + 'v1/get_sticky_config_list/', {bucketId : bucketId})
				.then(response => {
					if (!response.data.status) {
						this.notificationMsg('Warning', response.data.message);
					}
					this.stickyConfigsList = response.data.data;
				})
				.catch(e => {
					console.log(e);
				});
			},
			addStickyUnitConfig: function(){
				if (!this.stickyUnitConfig.layout || !this.stickyUnitConfig.layoutAdSpots) {
					this.notificationMsg('Error', 'Provide value for Sticky configuration.');
				}
				else {
					var formData = {
						editId: this.stickyUnitConfig.editId,
						bucketId : this.bucketId,
						layout : this.stickyUnitConfig.layout,
						adReferenceId : this.stickyUnitConfig.layoutAdSpots,
						startPoint : this.stickyUnitConfig.startPoint || '',
						endPoint : this.stickyUnitConfig.endPoint || '',
						timer : this.stickyUnitConfig.timer,
						isTimer : (this.stickyUnitConfig.timer) ? true :  false,
						moreCSS : (this.stickyUnitConfig.moreCSS) || '',
						top: this.stickyUnitConfig.top || 0,
					};

					axios.post(BASE_URL + 'v1/add_sticky_config/', formData)
					.then(response => {
						if (response.data.status) {
							this.stickyUnitConfig = JSON.parse(JSON.stringify(this.cloneConfig));
							this.notificationMsg('Success', response.data.message);
							this.getStickyUnitConfig(this.bucketId);
						}
						else this.notificationMsg('Error', response.data.message);
					})
					.catch(e => {
						console.log(e);
					});
				}
			},
			editStickyConfig: function(row){
				this.stickyUnitConfig.editId = row.id;
				this.stickyUnitConfig.layout = row.layout_id;
				this.stickyUnitConfig.isTimer = (row.timer > 0) ? true : false;
				this.stickyUnitConfig.startPoint = row.startPoint;
				this.stickyUnitConfig.endPoint = row.endPoint;
				this.stickyUnitConfig.timer = row.timer;
				this.stickyUnitConfig.moreCSS = row.more_css;
				this.stickyUnitConfig.top = row.top;

				this.getAdSpots(row.layout_id, (status) => {
					setTimeout(() => {
						this.stickyUnitConfig.layoutAdSpots = row.ref_id;
					});
				});
			},
			deleteStickyUnitConfig: function(row){
				var i = 0, 
					idx = this.stickyConfigsList.length, 
					selectedStickyUnit = [];

				selectedStickyUnit.push(row.id);
				if (selectedStickyUnit.length > 0) {
					var formData = {
						'bucketId' : this.bucketId,
						'selectedUnit' : selectedStickyUnit
					}
					axios.post(BASE_URL + 'v1/delete_sticky_unit_config/', formData)
					.then(response => {
						if (response.data.status) {
							this.getStickyUnitConfig(this.bucketId);
							this.notificationMsg('Success', response.data.message);
						} else {
							this.notificationMsg('Success', response.data.message);
						}
					})
					.catch(e => {
						console.log(e);
					});
				} else {
					this.notificationMsg('Warning', 'Select Sticky unit to Delete.');
				}
			},
			selectBucketModule(index){
				this.selectedBucketToImportConfig = this.bucketListForModuleConfig[index].id;
				this.selectedBucketNameToImportConfig = this.bucketListForModuleConfig[index].bucketName;
				this.getStickyConfig(this.selectedBucketToImportConfig);
				this.getStickyUnitConfig(this.selectedBucketToImportConfig);
				this.notificationMsg('Success', 'Imported Successfully! click save to use this config.');
			},
			removeSelectedModuleConfig(){
				this.selectedBucketToImportConfig = undefined;
				this.selectedBucketNameToImportConfig = undefined;
				this.stickyConfigsList = [];
				this.stickyConfig['isEnabled'] = false;
			},
			getAdunits(query){
				if(query){
					axios.post(BASE_URL + 'v1/get_dfp_adunits/', {bucketId : this.bucketId, query : query})
					.then(response => {
						if (response.data.response_data.status) {
							this.adunits = response.data.response_data.dfp_unit_list;
						}
					})
					.catch(e => {
						console.log(e);
					});
				}
			},
			getAdSpots(query, callback){
				if (query) {
					var requestData = {
						"layoutId" : query
 					}
					axios.post(BASE_URL + 'v1/get_layout_adspots/', requestData).then(response => {
						this.layoutAdSpotsList = response.data.data;
						console.log(callback);
						if(callback !== undefined){ 
							console.log(0);
							callback(true);
						}
					})
					.catch(e => {
						
					});
				}
			},
			importStickyConfig(){
				console.log("Import Config from this bucket "+this.selectedBucketToImportConfig+" to this one "+this.bucketId);
				axios.post(BASE_URL + 'v1/import_sticky_config/', {
					bucketId: this.bucketId,
					importFrmBucket: this.selectedBucketToImportConfig
				})
				.then(response => {
					if (response.data.status) {
						this.notificationMsg('Success',response.data.message);
						this.selectedBucketToImportConfig = undefined;
						this.selectedBucketNameToImportConfig = undefined;
						this.getStickyUnitConfig(this.bucketId);
					} else {
						this.notificationMsg('Warning',response.data.message);
					}
				})
				.catch(e => {
					console.log(e);
				});
			}
		}
	};
</script>
<style scoped>
	.form-label{
		font-weight: bold;
		text-transform: capitalize;
	}
	.flash{
		background: none !important;
		padding: 0px 20px !important;
	}

	.content-wrapper .content{
		padding-top: 95px;
	}
	.el-select{
		display: block;
	}
	ul.bucket-list {
		display: block;
		padding: 0;
		margin: 0;
	}
	ul.bucket-list li.buckets{
		display: inline-block;
		padding: 5px 20px;
		background: #7C6EB8;
		border-radius: 40px;
		margin-right: 10px;
	}
	ul.bucket-list li.buckets span{
		color: #ffffff;
	}
	ul.bucket-list li.no-result{
		display: block;
	}

	/*.content {
		padding-top: 75px !important;
	}*/

	.box-body{
		padding: 15px !important;
	}

	.heading-cart{
		position: relative;
		padding-left: 15px;
		padding-right: 15px;
	}
	.m-t-5{
		margin-top: 10px;
	}
	.heading-cart{
		margin-bottom: 0;
	}

	.configuration-box{
		min-height: 150px !important;
		max-height: 150px !important;
		overflow-x: scroll !important;
	}

	.box-title {
		display: inline-block;
		font-size: 12px;
		margin: 0;
		line-height: 1;
	}

	.row{
		/*border-top: 1px solid #eee !important;*/
		padding-top: 10px !important; 
	}

	.btn-mt{
		margin-top: 28px !important;
	}


	.no-padding{
		padding: 0px !important;
	}

	input[type=number]::-webkit-inner-spin-button, 
	input[type=number]::-webkit-outer-spin-button { 
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		margin: 0; 
	}

	.el-button{
		overflow: hidden !important;
		text-overflow: ellipsis !important;
		max-width: 130px !important;
		-webkit-line-clamp: 2 !important;
		-webkit-box-orient: vertical !important;
	}
	.el-button.edit{
		padding: 5px 10px;
	}
</style>
<style type="text/css">
	.import .el-button {
	    padding: 7px 10px;
	}
</style>


// WEBPACK FOOTER //
// ConfigStickyTemplate.vue?7846f6f5